import * as yup from 'yup';

export const ServiceParkPermitConf = {
  schema: {
    operation_service: yup.string().nullable().required('Service is required'),
  },
  defaultValues: {
    operation_service: null,
  },
  fields: [
    {
      id: 'service_divider',
      type: 'divider',
      label: 'Service',
      xs: 12,
    },
    {
      id: 'operation_service',
      name: 'operation_service',
      type: 'text',
      label: 'Service',
      required: true,
      xs: 12,
    },
  ],
};